import { render, staticRenderFns } from "./AssetMessage.vue?vue&type=template&id=35902da6&scoped=true"
import script from "./AssetMessage.vue?vue&type=script&lang=js"
export * from "./AssetMessage.vue?vue&type=script&lang=js"
import style0 from "./AssetMessage.vue?vue&type=style&index=0&id=35902da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35902da6",
  null
  
)

export default component.exports